<template>
  <v-app
    :style="{
      background: $vuetify.theme.themes[theme].background,
      'font-family': $vuetify.theme.themes[theme].fontFamily,
    }"
  >
    <v-app-bar app elevate-on-scroll color="blue">
      <v-container>
        <v-toolbar-title class="font-weight-bold white--text"
          >Carole ALÉTRU - Prise de rendez-vous</v-toolbar-title
        >
      </v-container>
    </v-app-bar>
    <v-main>
      <v-container class="d-flex justify-center align-center flex-column mt-12">
        <p>La prise de rendez-vous en ligne se fait désormais via Doctolib :</p>
        <v-btn color="primary" href="https://www.doctolib.fr/osteopathe/saint-laurent-de-la-salle/carole-aletru">Accéder à Doctolib</v-btn>
      </v-container>
      
    </v-main>
  </v-app>
</template>

<script>
// import MotifDeConsultation from "../frontend/MotifDeConsultation";
//import ChoixDate from "../frontend/ChoixDate";
//import Rappels from "../frontend/Rappels";
//import DescriptionMotifDeConsultation from "../frontend/DescriptionMotifDeConsultation";
//import EtapeItem from "../../components/EtapeItem";

export default {
  // components: {
  //   MotifDeConsultation,
  //   EtapeItem,
  //   ChoixDate,
  //   DescriptionMotifDeConsultation,
  //   Rappels,
  // },
  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
    etape() {
      return this.$store.state.etape;
    },
    questionnaireCovidRempli() {
      return this.$store.state.questionnaireCovidRempli;
    },
    motifDeConsultationRempli() {
      return this.$store.state.motifDeConsultationRempli;
    },
    dateChoisie() {
      return this.$store.state.dateChoisie;
    },
    dossierMedicalRempli() {
      return this.$store.state.dossierMedicalRempli;
    },
    rappelsLus() {
      return this.$store.state.rappelsLus;
    },
  },
  data: () => ({}),
};
</script>


